<div class="lib-onboarding">
  @if (variant === 'empty') {
    <p class="lib-onboarding__title">{{ 'tenders.responses.documents.library-health.empty-title' | translate }}</p>
    <p class="lib-onboarding__body">{{ 'tenders.responses.documents.library-health.empty-body' | translate }}</p>
  } @else {
    <p class="lib-onboarding__title">{{ 'tenders.responses.documents.library-health.low-title' | translate }}</p>
    <p class="lib-onboarding__body">{{ 'tenders.responses.documents.library-health.low-onboarding-body' | translate }}</p>
  }

  <div class="lib-onboarding__actions">
    <ex-button type="primary" size="large" icon="books" [disabled]="disabled" (click)="goToLibrary.emit()">
      {{ 'tenders.responses.documents.library-health.enrich-cta' | translate }}
    </ex-button>
    <button type="button" class="lib-onboarding__later" [disabled]="disabled" (click)="later.emit()">
      {{
        (variant === 'empty'
          ? 'tenders.responses.documents.library-health.later-empty'
          : 'tenders.responses.documents.library-health.later-low'
        ) | translate
      }}
    </button>
  </div>
</div>
